import styled from '@emotion/styled'

import { css } from '@emotion/react'

const Container = styled.h2`
  & {
    font-size: var(--fs-800);
    font-weight: 500;
    color: ${({ theme }) => theme.colors.secondary[900]};
    text-align: center;
  }

  & > * {
    display: block;
  }

  & > *:only-child {
    margin: 0 0 62px 0;
  }

  & > *:not(:only-child) {
    margin: 0 0 0 0;
  }

  & > *:not(:only-child):last-child {
    font-size: var(--fs-570);
    font-weight: 300;
    line-height: normal;
    margin: 0 0 32px 0;
  }

  & .primary {
    color: ${({ theme }) => theme.colors.primary[400]};
  }

  & .tertiary {
    color: ${({ theme }) => theme.colors.tertiary[400]};
  }

  ${({ theme }) =>
    css(
      theme.size.mq({
        '&': {
          fontSize: [
            'var(--fs-570)',
            'var(--fs-570)',
            'var(--fs-800)',
            'var(--fs-800)',
          ],
        },
        '& > *:only-child': {
          margin: ['0 0 35px 0', '0 0 35px 0', '0 0 52px 0', '0 0 84px 0'],
        },
        '& > *:not(:only-child):last-child': {
          fontSize: [
            'var(--fs-50)',
            'var(--fs-50)',
            'var(--fs-500)',
            'var(--fs-570)',
          ],
        },
      }),
    ).styles}}
`

export default Container
